/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { OrderIncompleteDeliveryReason } from './OrderIncompleteDeliveryReason';
// @ts-ignore
import {
// @ts-ignore
    OrderIncompleteDeliveryReasonFromJSON,
// @ts-ignore
    OrderIncompleteDeliveryReasonFromJSONTyped,
// @ts-ignore
    OrderIncompleteDeliveryReasonToJSON,
} from './OrderIncompleteDeliveryReason';

/**
 * 
 * @export
 * @interface OrderUnresolvedIncompleteDelivery
 */
export interface OrderUnresolvedIncompleteDelivery {
    /**
     * 
     * @type {string}
     * @memberof OrderUnresolvedIncompleteDelivery
     */
    id: string;
    /**
     * 
     * @type {OrderIncompleteDeliveryReason}
     * @memberof OrderUnresolvedIncompleteDelivery
     */
    reason: OrderIncompleteDeliveryReason;
    /**
     * 
     * @type {string}
     * @memberof OrderUnresolvedIncompleteDelivery
     */
    comment?: string;
}

/**
 * Check if a given object implements the OrderUnresolvedIncompleteDelivery interface.
 */
// @ts-ignore
export function instanceOfOrderUnresolvedIncompleteDelivery(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "reason" in value;

    return isInstance;
}

// @ts-ignore
export function OrderUnresolvedIncompleteDeliveryFromJSON(json: any): OrderUnresolvedIncompleteDelivery {
    return OrderUnresolvedIncompleteDeliveryFromJSONTyped(json, false);
}

// @ts-ignore
export function OrderUnresolvedIncompleteDeliveryFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderUnresolvedIncompleteDelivery {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'reason': OrderIncompleteDeliveryReasonFromJSON(json['reason']),
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
    };
}

// @ts-ignore
export function OrderUnresolvedIncompleteDeliveryToJSON(value?: OrderUnresolvedIncompleteDelivery | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'reason': OrderIncompleteDeliveryReasonToJSON(value.reason),
        'comment': value.comment,
    };
}

